import "./index.css";

const SkeletonSubscriptionCard = () => {
  return (
    <div className="col-lg-4 col-md-6 mb-2">
      <div className="card subscription-card shadow d-flex flex-column skeleton-card">
        <div className="card-header-image skeleton-box"></div>
        <div className="card-body text-center d-flex flex-column flex-grow-1">
          <div className="skeleton-text title"></div>
          <div className="skeleton-text description"></div>
          <div className="card-price mb-2">
            <div className="skeleton-text price"></div>
          </div>
          <ul className="feature-list text-start mb-2">
            {[1, 2, 3, 4].map((_, idx) => (
              <li key={idx} className="skeleton-text feature-line"></li>
            ))}
          </ul>
          <div className="mt-auto">
            <div className="skeleton-button"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SkeletonSubscriptionCard;
